import React from 'react';
import * as R from 'ramda';
import { deleteService } from '../../../../actions/user-api';
import { useDispatch, useSelector } from 'react-redux';
import {ConnectionTypes} from '../../../../constants/utils/connectionTypes';
import {getProgress} from './calculateProgress';

export const CheckboxCard = ({ labels, isSelected, topRef, isSocialNetwork, isInsurance, selectedServices, setSelectedServices, service }) => {
    const dispatch = useDispatch();
    const services = useSelector(state => state.services);
    const user = useSelector(state => state.user);
    // const mandatory = [ConnectionTypes.notary, ConnectionTypes.socialSecurity, ConnectionTypes.bank, ConnectionTypes.mutual, ConnectionTypes.homeInsurance, ConnectionTypes.waterSupplier, ConnectionTypes.electricityProvider, ConnectionTypes.mobilePhone, ConnectionTypes.taxes];

    let progress =  getProgress(services.serviceData, service.connectionType);

    function AddOrRemove(option) {
        let optionIsSocNet = option.connectionType === ConnectionTypes.socialNetworks;
        let optionIsVehicleIns = option.connectionType === ConnectionTypes.insurance;

        let tmpSelected = JSON.parse(JSON.stringify(selectedServices));
        if (tmpSelected.findIndex(o => optionIsSocNet ? isSocialNetwork(o.connectionType) : optionIsVehicleIns ? isInsurance(o.connectionType): o.connectionType === option.connectionType) !== -1) {
            // if (!mandatory.includes(option.connectionType)) {
                tmpSelected = tmpSelected.filter(o => optionIsSocNet ? !isSocialNetwork(o.connectionType) : optionIsVehicleIns ? !isInsurance(o.connectionType) : o.connectionType !== option.connectionType);
                let servicesToDelete = user.services.filter(sv => optionIsSocNet ? isSocialNetwork(sv.connectionType) : optionIsVehicleIns ? isInsurance(sv.connectionType) :
                    sv.connectionType === option.connectionType);

                servicesToDelete.forEach(serviceToDelete => {
                    dispatch(deleteService(user.user, serviceToDelete));
                });
                if (!R.isNil(topRef) && !R.isNil(topRef.current)) {
                    topRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            // }
        }
        setSelectedServices(tmpSelected);
    }

    return (
        <>
            <div className="card-header card-media">
                <div className="card-target w-4 d-inherit text-center my-auto">
                    <img className="img-fluid m-auto py-1 w-4" src={service.icon} alt={service.title} />
                </div>
                {
                    isSelected ?
                        <div className="media-body my-auto text-truncate">
                            <div className="flex-row">
                                <h3 className="card-target h5 o-40 text-uppercase font-weight-bolder my-auto mr-2 text-truncate">{service.title}</h3>
                                <div className="my-auto ml-auto">
                                <i role="button" className="eva eva-trash-2-outline mr-2 fs-root align-middle" onClick={() => AddOrRemove(service)}></i>
                                    {/* <button type="button" className="btn btn-icon btn-options p-1 mr-n1" id="dropdownMenuServiceoptions" data-toggle="dropdown" data-reference="parent">
                                        <i className="eva eva-more-vertical-outline fs-sm lh-1"></i>
                                    </button> */}
                                    {/* <ul className="dropdown-menu z-max border-none shadow-xs" aria-labelledby="dropdownMenuServiceoptions"> */}
                                        {/* <li><button className="dropdown-item px-3 fs-3" onClick={() => AddOrRemove(service)}><i className="eva eva-trash-2-outline mr-2 fs-root align-middle"></i><span className="o-70 align-middle">Supprimer</span></button></li> */}
                                        {/* <li><button className="dropdown-item px-3 fs-3"><i className="eva eva-trash-2-outline mr-2 fs-root align-middle"></i><span className="o-70 align-middle">Reset service</span></button></li> */}
                                    {/* </ul> */}
                                </div>
                            </div>
                        </div>
                        :
                        <div className="media-body my-auto">
                            <div className="media my-2">
                                <h3 className="card-target h5 o-40 text-uppercase font-weight-bolder my-auto mr-2">{service.title}</h3>
                                {/* <i className="eva eva-eye-off-outline text-danger--hover ml-auto o-30 o-100--hover fs-sm lh-1"></i> */}
                            </div>
                            <div className={"card-target progress position-relative mb-auto w-100 h-sm text-center rounded-max align-items-center" + (progress === 100 ? ' bg-white' : ' bg-common 0')}>
                                <div className={"progress-bar h-100 rounded-inherit" + (progress === 100 ? ' bg-success o-20' : ' gradient-prime o-50')} style={{ width: `${progress}%` }} role="progressbar"></div>
                                <div className={"position-absolute m-auto justify-content-center w-100 font-weight-bolder" + (progress === 100 ? ' text-success' : ' o-80')} role="progressbar">{progress}%</div>
                            </div>
                        </div>
                }
            </div>
            {
                isSelected ?
                    <div className="card-body pt-0">
                        {
                            !R.isNil(labels) && labels.length > 0 ?
                            <div className="mb-2">
                                {
                                    !R.isNil(labels) && labels.length > 0 && labels.map((label, index) => {
                                        return (<div key={index} className={"step-item" + (label.isActive ? ' active' : '')}><i className="eva eva-checkmark step-check mr-2"></i>{label.name}</div>)
                                    })
                                }
                            </div>
                            : ''
                        }
                        <hr className="w-auto mt-0" />
                        <div className={"progress position-relative mb-auto w-100 h-sm text-center rounded-max align-items-center" + (progress === 100 ? ' bg-white' : ' bg-common 0')}>
                            <div className={"progress-bar h-100 rounded-inherit" + (progress === 100 ? ' bg-success o-20' : ' gradient-prime o-50')} style={{ width: `${progress}%` }} role="progressbar"></div>
                            <div className={"d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder" + (progress === 100 ? ' text-success' : ' o-80')} role="progressbar">{progress}%</div>
                        </div>
                    </div>
                    :
                    ''
            }
        </>
    )
}